import { render, staticRenderFns } from "./ColorKitInfo.vue?vue&type=template&id=08235938&scoped=true&lang=pug&"
import script from "./ColorKitInfo.vue?vue&type=script&lang=js&"
export * from "./ColorKitInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitInfo.vue?vue&type=style&index=0&id=08235938&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08235938",
  null
  
)

export default component.exports